import { FC, MouseEventHandler, ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import { useBuyerIncentivesMessages } from 'dibs-buyer-incentives/exports/useBuyerIncentivesMessages';

import dibsCss from 'dibs-css';

const IncentiveWithComma: FC<{ incentive: ReactNode }> = ({ incentive }) => (
    <FormattedMessage
        id="PdpSharedSidebarBuyerIncentives.incentiveWithComma"
        defaultMessage="{incentive},"
        values={{ incentive }}
    />
);

const PdpSharedSidebarBuyerIncentives: FC<{
    onDetailsClick?: MouseEventHandler;
}> = ({ onDetailsClick }) => {
    const incentives = useBuyerIncentivesMessages();

    return (
        <FormattedMessage
            id="PdpSharedSidebarBuyerIncentives.promise"
            defaultMessage="<strong>The 1stDibs Promise:</strong> {incentive1} {incentive2} {incentive3}"
            values={{
                strong: chunk => <strong>{chunk}</strong>,
                incentive1: (
                    <div className={dibsCss.inlineBlock}>
                        <IncentiveWithComma incentive={incentives[0]} />
                    </div>
                ),
                incentive2: (
                    <div className={dibsCss.inlineBlock}>
                        <IncentiveWithComma incentive={incentives[1]} />
                    </div>
                ),
                incentive3: (
                    <div className={dibsCss.inlineBlock}>
                        {incentives[2]}
                        {onDetailsClick ? (
                            <>
                                {' '}
                                <Link onClick={onDetailsClick}>
                                    <FormattedMessage
                                        id="PdpSharedSidebarBuyerIncentives.learnMore"
                                        defaultMessage="Details"
                                    />
                                </Link>
                            </>
                        ) : null}
                    </div>
                ),
            }}
        />
    );
};

export default PdpSharedSidebarBuyerIncentives;
